import React from "react";
import ReactDOM from "react-dom";
import reactToWebComponent from "react-to-webcomponent";
import { ThemeProvider } from "styled-components";
import PropTypes from "prop-types";

import { Heading1 } from "@ibinder/ui-common-core";
import { iBinderMainTheme } from "@ibinder/ui-common-styles";

interface Props {
  label?: string;
}

const Index = ({ label = "labelText", ...props }: Props) => {
  return (
    <ThemeProvider theme={iBinderMainTheme}>
      <Heading1 label={label} />
    </ThemeProvider>
  );
};

Index.propTypes = {
  label: PropTypes.string.isRequired
};

customElements.define(
  "ibinder-heading1",
  // @ts-ignore
  reactToWebComponent(Index, React, ReactDOM)
);
